import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export type Config = {
  sdSingle: number;
  hdSingle: number;
  sdAbr: number;
  hdAbr: number;
  packaging: number;
};

export const configApi = createApi({
  reducerPath: 'configApi',
  baseQuery: fetchBaseQuery({ baseUrl: import.meta.env.BASE_URL }),
  endpoints: builder => ({
    getConfig: builder.query<Config, void>({
      query: () => 'config.json',
      transformErrorResponse: () => ({
        sdSingle: 33,
        hdSingle: 9,
        sdAbr: 22,
        hdAbr: 7,
        packaging: 40,
      }),
    }),
  }),
});

export const { useGetConfigQuery } = configApi;
